import { BaseDto } from "./base.dto"
import { DateOfBirthDto } from "./date-of-birth.dto"
import { FileDto } from "./file.dto"
import { PagingDto } from "./paging.dto"
import { ProductDetailDto, ProductDto } from "./product.dto"

export class FindCollectionDto extends PagingDto {
  status?: string
  searchText?: string
}

export class CollectionDto extends BaseDto {
  name: string
  nameKh: string
  icon: FileDto
  mobileIcon: FileDto
  enabled: boolean
  sortOrder: number
  endDate: DateOfBirthDto
  numberOfTenants: number
  isFinished: boolean
  status: string
  hasNew: boolean

  static create() {
    return new CollectionDto()
  }
}

export class FindCollectionItemDto extends PagingDto {
  status: string
  searchText?: string
  tenantId: string
}

export class CollectionItemDto extends BaseDto {
  product: ProductDetailDto
  status: string
}

export class CreateCollectionDto {
  name: string
  nameKh: string
  iconId: string
  mobileIconId: string
  endDate?: DateOfBirthDto
}

export class UpdateCollectionDto {
  name?: string
  nameKh?: string
  iconId?: string
  mobileIconId?: string
  endDate?: DateOfBirthDto
}

export class CollectionTenantDto {
  numberOfProducts: number
  tenantId: string
  tenantName: string
  isNew: boolean
}